import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { adminApi } from '@/lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refreshUser = useCallback(async () => {
        const token = localStorage.getItem('vvvsi_admin_token');
        if (!token) {
            setUser(null);
            setLoading(false);
            return;
        }
        try {
            const me = await adminApi.me();
            setUser(me);
        } catch (e) {
            localStorage.removeItem('vvvsi_admin_token');
            setUser(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        refreshUser();
    }, [refreshUser]);

    const login = async (email, password) => {
        const data = await adminApi.login(email, password);
        localStorage.setItem('vvvsi_admin_token', data.access_token);
        setUser(data.user);
        return data.user;
    };

    const logout = () => {
        localStorage.removeItem('vvvsi_admin_token');
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, logout, refreshUser }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error('useAuth must be used within AuthProvider');
    return ctx;
};
